export default {
    PROCESS_RES: (state, data) => {
        state.items = data.items;
        state.pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1
        };
    },

    SET_ITEMS: (state, data) => {
        state.items = data;
    },

    UPDATE_FILTERS(state, filters) {
        Object.assign(state.filters, filters);
    }
};
